module.exports = __webpack_public_path__ + "assets/img/gacc.d4d066e0.svg";